/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorological Institute (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

// Function to transform bird density to BirdTAM value
export function densityToBirdTAM(density: number): number {
  if (density > 160) {
    return 9;
  }
  if (density > 80) {
    return 8;
  }
  if (density > 40) {
    return 7;
  }
  if (density > 20) {
    return 6;
  }
  if (density > 10) {
    return 5;
  }
  if (density > 5) {
    return 4;
  }
  if (density > 2.5) {
    return 3;
  }
  if (density > 1.25) {
    return 2;
  }
  if (density > 0.625) {
    return 1;
  }
  return 0; // Effectively 0 birds
}

// Function to transform BirdTAM to bird density value
export function birdTAMToDensity(birdTAM: number): number {
  if (birdTAM === 9) {
    return 160;
  }
  if (birdTAM === 8) {
    return 80;
  }
  if (birdTAM === 7) {
    return 40;
  }
  if (birdTAM === 6) {
    return 20;
  }
  if (birdTAM === 5) {
    return 10;
  }
  if (birdTAM === 4) {
    return 5;
  }
  if (birdTAM === 3) {
    return 2.5;
  }
  if (birdTAM === 2) {
    return 1.125;
  }
  if (birdTAM === 1) {
    return 0.625;
  }
  return 0; // Effectively 0 birds
}
